export default "__VITE_PUBLIC_ASSET__e89cce5d__"